<template>
  <ResultForm :data="initData" @save="save"></ResultForm>
</template>
<script>
import LottoService from "@/services/lottoService"

import moment from "moment"

import ResultForm from "./ResultForm.vue"

export default {
  components: {
    ResultForm
  },
  data() {
    return {
      lotto: null
    }
  },
  computed: {
    initData() {
      let data = this.lotto
      let results = {}
      let checkUnique = []
      for (const [key, value] of Object.entries(this.lotto.results)) {
        if(value.length > 0) {
          let setValue = ''
          if(checkUnique.includes(value)){
            setValue = LottoService.randomNumber(value.length)
          }else{
            setValue = value
          }
          checkUnique.push(setValue)
          results[key] = setValue
        }else{
          results[key] = ''
        }
      }
      data.results = results
      return data
    },
    lottoType() {
      return this.$route.params.lottoType
    }
  },
  watch: {
    lottoType() {
      this.setData()
    }
  },
  methods: {
    save(data) {
      LottoService.saveResult({
        ...data,
        lotto_id: moment(data.lotto_date).format("YYYY-MM-DD")+'-'+data.round
      }).then((response) => {
        try {
          if (response.status === 'success') {
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'บันทึกผลหวยเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });

            this.$router.push({ name: 'admin-lotto-results', params: { lottoType: data.lotto_type } })
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'บันทึกผลหวยไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        } catch (e) {
          //console.log(e)
          this.$vs.notify({
            title: 'ผิดพลาด(2)!',
            text: 'บันทึกผลหวยไม่สำเร็จ',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      })
    },
    setData() {
      switch(this.$route.params.lottoType) {
        case 'gb':
          this.lotto = {
            lotto_type: this.$route.params.lottoType,
            lotto_date: moment().format("YYYY-MM-DD"),
            lotto_id: null,
            round: 'r1',
            start_spin: moment().format("YYYY-MM-DD 21:40"),
            show_1st: moment().format("YYYY-MM-DD 21:50"),
            show_2nd: moment().format("YYYY-MM-DD 21:45"),
            results: {
              prize_1st: '',
              prize_2nd: '',
              prize_3rd_1: LottoService.randomNumber(5),
              prize_3rd_2: LottoService.randomNumber(5),
              prize_3rd_3: LottoService.randomNumber(5),
              prize_3rd_4: LottoService.randomNumber(5),
              prize_3rd_5: LottoService.randomNumber(5),
              prize_3rd_6: LottoService.randomNumber(5),
              prize_3rd_7: LottoService.randomNumber(5),
              prize_3rd_8: LottoService.randomNumber(5)
            }
          }
          break
        case 'de':
          this.lotto = {
            lotto_type: this.$route.params.lottoType,
            lotto_date: moment().format("YYYY-MM-DD"),
            lotto_id: null,
            round: 'r1',
            start_spin: moment().format("YYYY-MM-DD 22:40"),
            show_1st: moment().format("YYYY-MM-DD 22:50"),
            show_2nd: moment().format("YYYY-MM-DD 22:45"),
            results: {
              prize_1st: '',
              prize_2nd: '',
              prize_3rd_1: LottoService.randomNumber(5),
              prize_3rd_2: LottoService.randomNumber(5),
              prize_3rd_3: LottoService.randomNumber(5),
              prize_3rd_4: LottoService.randomNumber(5),
              prize_3rd_5: LottoService.randomNumber(5),
              prize_3rd_6: LottoService.randomNumber(5),
              prize_3rd_7: LottoService.randomNumber(5),
              prize_3rd_8: LottoService.randomNumber(5)
            }
          }
          break
        case 'ru':
          this.lotto = {
            lotto_type: this.$route.params.lottoType,
            lotto_date: moment().format("YYYY-MM-DD"),
            lotto_id: null,
            round: 'r1',
            start_spin: moment().format("YYYY-MM-DD 23:40"),
            show_1st: moment().format("YYYY-MM-DD 23:50"),
            show_2nd: moment().format("YYYY-MM-DD 23:45"),
            results: {
              prize_1st: '',
              prize_2nd: '',
              prize_3rd_1: LottoService.randomNumber(5),
              prize_3rd_2: LottoService.randomNumber(5),
              prize_3rd_3: LottoService.randomNumber(5),
              prize_3rd_4: LottoService.randomNumber(5),
              prize_3rd_5: LottoService.randomNumber(5),
              prize_3rd_6: LottoService.randomNumber(5),
              prize_3rd_7: LottoService.randomNumber(5),
              prize_3rd_8: LottoService.randomNumber(5)
            }
          }
          break
      }
    }
  },
  created() {
    this.setData()
  }
}

</script>
